import React from 'react';
import { Monitor, Phone, Mail, MapPin } from 'lucide-react';
import { company, navLinks } from '../mock';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5">
              <div className="w-9 h-9 rounded-lg bg-blue-600 flex items-center justify-center text-white">
                <Monitor size={20} />
              </div>
              <div className="font-heading font-bold text-white text-lg">{company.name} <span className="text-cyan-400">{company.suffix}</span></div>
            </div>
            <p className="mt-4 text-sm text-slate-400 leading-relaxed">
              Professional technical support for all brands, software, and antivirus solutions. Keeping your business running smoothly.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white">Quick Links</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {navLinks.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="text-slate-400 hover:text-cyan-400 transition-colors">{l.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white">Services</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-slate-400">
              <li>Computer Support</li>
              <li>Software Support</li>
              <li>Antivirus Support</li>
              <li>Network Security</li>
              <li>Onsite Repairs</li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white">Contact</h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <Phone size={16} className="text-cyan-400 mt-0.5 shrink-0" />
                <a href={company.phoneHref} className="text-slate-400 hover:text-cyan-400">{company.phone}</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={16} className="text-cyan-400 mt-0.5 shrink-0" />
                <a href={`mailto:${company.email}`} className="text-slate-400 hover:text-cyan-400 break-all">{company.email}</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-cyan-400 mt-0.5 shrink-0" />
                <span className="text-slate-400">{company.address.line1}, {company.address.city}, {company.address.country}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-slate-800 text-center text-sm text-slate-500">
          © {new Date().getFullYear()} {company.name} {company.suffix}. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
